module.exports = "./img/a305996064feea40366c4ed3e0f6fb24.jpg";